export var INIIALIZE = "@@firekit/PATHS@INIIALIZE";
export var DESTROY = "@@firekit/PATHS@DESTROY";
export var UNWATCH = "@@firekit/PATHS@UNWATCH";
export var VALUE_CHANGED = "@@firekit/PATHS@VALUE_CHANGED";